module.exports = __webpack_public_path__ + "assets/otc-worldclass-icon.e9781596.svg";